import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostListener,
	OnDestroy,
	OnInit,
} from "@angular/core";
import {
	AbstractControl,
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService, UserData } from "@kdose/ng-auth";
import { Observable, takeUntil } from "rxjs";
import {
	ChangePasswordService,
	PasswordsMatchValidator,
} from "./change-password.service";

const PASSWORD_PATTERN =
	/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,}$/;

@Component({
	selector: "app-changepassword-form",
	templateUrl: "./change-password-form.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ChangePasswordFormComponent implements OnInit, OnDestroy {
	public readonly pattern = PASSWORD_PATTERN;

	private readonly destroy$ = new EventEmitter<void>();

	form: UntypedFormGroup;
	filter: any;
	isLocalUser = false;

	constructor(
		private auth: AuthenticationService,
		private service: ChangePasswordService,
		public route: ActivatedRoute,
		public router: Router,
		private fb: UntypedFormBuilder,
	) {
		this.form = this.fb.group(
			{
				oldPassword: "",
				newPassword: [
					"",
					Validators.compose([
						Validators.required,
						Validators.pattern(PASSWORD_PATTERN),
					]),
				],
				repeatedPassword: [
					"",
					Validators.compose([
						Validators.required,
						Validators.pattern(PASSWORD_PATTERN),
					]),
				],
			},
			{ validators: PasswordsMatchValidator },
		);
	}

	ngOnInit(): void {
		this.auth.userData
			.pipe(takeUntil(this.destroy$))
			.subscribe((data: UserData & { type: string }) => {
				// TODO: bei Angular-18-Migration Parametertyp anpassen
				this.isLocalUser = data.type?.toLocaleLowerCase() === "local";
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	onSubmit(event: SubmitEvent) {
		event.stopPropagation();
		event.preventDefault();

		this.form.updateValueAndValidity();
		if (this.form.invalid) {
			return;
		}

		const { oldPassword, newPassword } = this.form.value as {
			oldPassword: string;
			newPassword: string;
			repeatedPassword: string;
		};
		this.service
			.changePassword({
				oldPassword,
				newPassword,
			})
			.subscribe(() => {
				this.auth.logout();
				setTimeout(() => this.router.navigateByUrl("/login"), 5);
			});

		return false;
	}

	@HostListener("window:beforeunload")
	canDeactivate(): Observable<boolean> | boolean {
		return !this.form.dirty;
	}

	get newPassword(): AbstractControl {
		return this.form.get("newPassword");
	}
}
